import { Box, Button, InputBase, Typography,TextField } from "@mui/material";
import otpImg from '../Assets/otp-img.svg'
import { useState , useEffect} from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { updateFirst_name, updateId, updateLast_name, updateMobileno, updateSelectedHub } from "../Redux/user";
import { updatepageName } from "../Redux/page";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import CustomAxios from "../utils/CustomAxios";
import CircularProgress from '@mui/material/CircularProgress';
export function OtpVerification() {
    const toast = useRef(null);
    const [loading, setLoading] = useState(false)
    const [resend_loading, setresendLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const inputRefs = useRef([]);
    const [otp, setOtp] = useState(new Array(6).fill(""));

    
    const [timer,setTimer] = useState(180)
    const [isOtpFilled, setIsOtpFilled] = useState(false);



    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(interval);
        } else {
            toast.current.show({ severity: 'error', summary: 'OTP Expired', detail: 'Please request a new OTP.', life: 3000 });
            setOtp(new Array(6).fill("")); 
        }
    }, [timer]);
    
    useEffect(() => {
        setIsOtpFilled(otp.join("").length === 6);
    }, [otp]);
    
    // Convert seconds to MM:SS format
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };

    const handleChange = (index, event) => {
        const value = event.target.value;
        if (!/^[0-9]?$/.test(value)) return;

        let newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
        if (event.key === 'Enter') {
            event.preventDefault();
            handleOtpSubmit(event);
          }
    };

    console.log('otp--',otp)
    
    const mobileno = localStorage.getItem("mobileno")

    useEffect(() => {
        console.log("Verifying OTP for mobileno:", mobileno);
    }, [mobileno]);

    useEffect(() => {
        const mobileno = localStorage.getItem('mobileno');
        if (!mobileno) {
          navigate('/');  
        }
      }, [navigate]);
      
      
    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        const otpString = otp.join("");

        if (timer === 0) {
            toast.current.show({ severity: 'error', summary: 'OTP Expired', detail: 'Please request a new OTP.', life: 3000 });
            return;
        }
    

        if (otpString.length !== 6) {
            toast.current.show({ severity: 'error', summary: 'Invalid OTP', detail: 'OTP must be exactly 6 digits', life: 3000 });
            return;
        }

        setLoading(true);
    
        try {
            
            const response = await CustomAxios.post(`otp-verification/`, { mobileno, otp: otpString });
    
            const data = response.data;
            console.log("OTP Verification Response:", data);

            /*
             * `staff_access` decides this now, not the message string.
             *
             * The panel used to require `message === "active user"`, which the
             * server only sets for a Django superuser. Every other valid admin,
             * supervisor or cashier got "inactive user" and this branch was
             * never taken -- the OTP succeeded and nothing happened.
             *
             * The string could not simply be widened: the customer app routes a
             * first login to its Welcome screen on exactly "inactive user", so
             * changing it would have moved every customer. The server now
             * answers this question on its own field and leaves the string be.
             */
            /*
             * Either signal, and only with credentials in hand.
             *
             * `staff_access` is the server's own answer and the one to trust.
             * The `message` fallback keeps this working against a backend that
             * predates that field -- without it, pointing the panel at an older
             * deployment locks every admin out.
             *
             * The token check is the important half. CustomAxios hard-redirects
             * to the login page on any request missing either token, so
             * navigating without both does not fail visibly -- it silently
             * bounces the operator back to login, which looks exactly like the
             * OTP having been rejected.
             */
            const mayEnterPanel = data.staff_access ?? (data.message === "active user");
            if (mayEnterPanel && data.access_token && data.refresh_token) {
                // Store tokens and user details
                localStorage.setItem("authtoken", data.access_token);
                localStorage.setItem("refreshToken", data.refresh_token);
                localStorage.setItem("role", data.user_data.role);
                localStorage.setItem("id", data.user_data.id);
                localStorage.setItem("first_name", data.user_data.first_name);
                localStorage.setItem("last_name", data.user_data.last_name);
    
                dispatch(updateFirst_name(data.user_data.first_name));
                dispatch(updateLast_name(data.user_data.last_name));
                dispatch(updateId(data.user_data.id));
                
                // Update hub data from OTP verification response
                // console.log("=== OTP VERIFICATION RESPONSE DEBUG ===");
                // console.log("User role:", data.user_data.role);
                // console.log("Inventory IDs:", data.inventory_ids);
                // console.log("=== END OTP VERIFICATION RESPONSE DEBUG ===");
                
                if (Array.isArray(data.inventory_ids) && data.inventory_ids.length > 0) {
                    localStorage.setItem('hub', JSON.stringify(data.inventory_ids));
                    localStorage.setItem('selected_hub', JSON.stringify(data.inventory_ids));
                    dispatch(updateSelectedHub(data.inventory_ids));
                    // console.log("OTP Verification - Set hub to:", data.inventory_ids);
                } else if (data.user_data.role === 'super_admin') {
                    // Super Admin gets all hubs - we'll handle this in the frontend
                    localStorage.setItem('hub', JSON.stringify([]));
                    localStorage.setItem('selected_hub', JSON.stringify([]));
                    dispatch(updateSelectedHub([]));
                    // console.log("OTP Verification - Super Admin - set empty hub array");
                } else {
                    localStorage.setItem('hub', JSON.stringify([]));
                    localStorage.setItem('selected_hub', JSON.stringify([]));
                    dispatch(updateSelectedHub([]));
                    // console.log("OTP Verification - No inventory IDs - set empty hub array");
                }
    
                /*
                 * Where a signed-in operator starts.
                 *
                 * Inventory, not Product Details: stock is what the day starts
                 * with, and it was the first thing everyone navigated to anyway.
                 *
                 * pageName is dispatched alongside the route because the sidebar
                 * highlights from redux, not from the URL. Its initial state is
                 * "product_details", so navigating without this left the sidebar
                 * marking a page the operator was not on.
                 */
                if (data.user_data.role === 'cashier') {
                    dispatch(updatepageName("order_management"));
                    navigate("/home/order_management");
                } else {
                    dispatch(updatepageName("inventory"));
                    navigate("/home/inventory");
                }
            } else {
                // Say what is actually wrong. `data.message` is an internal
                // string like "inactive user" -- it told the operator nothing
                // they could act on, least of all that the account had been
                // switched off or was never a staff account to begin with.
                const reason =
                    data.access_denied_reason ||
                    "This login is for staff accounts. Please use the Shino app.";
                toast.current.show({ severity: "error", summary: "Cannot sign in", detail: reason, life: 5000 });
            }
        } catch (error) {
            console.error("OTP Verification Error:", error);
    
            if (error.response) {
                const errorMessage = error.response.data?.message || "Invalid OTP";
                toast.current.show({ severity: "error", summary: "Error", detail: errorMessage, life: 3000 });
            } else {
                toast.current.show({ severity: "error", summary: "Error", detail: "Network Error", life: 3000 });
            }
        }
    
        setLoading(false);
    };
    

    const handleResendOtp = async () => {
        if (timer > 0) return; 
    
        const mobileno = localStorage.getItem("mobileno");
        console.log("Attempting to resend OTP for mobileno:", mobileno);
    
        if (!mobileno) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Mobile number is required', life: 3000 });
            return;
        }
    
        setresendLoading(true);
    
        try {
            const response = await CustomAxios.post(`regenerate-otp/`, { mobileno });
            const data = response.data;
    
            console.log("Resend OTP Response:", data);
    
            if (data.message === "New OTP has been sent to your new mobile number.") {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'OTP has been resent.', life: 3000 });
    
                // Clear the OTP input fields
                setOtp(new Array(6).fill(""));
    
                // Move focus to the first input box
                inputRefs.current[0]?.focus();
    
                setTimer(180);
            } else {
                console.log("Error:", data.message);
                toast.current.show({ severity: 'error', summary: 'Error', detail: data.message, life: 3000 });
            }
        } catch (e) {
            console.error("Resend OTP Error:", e);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to resend OTP', life: 3000 });
        }
    
        setresendLoading(false);
    };
    
    useEffect(() => {
        // Both tokens, not just one. CustomAxios refuses to send a request
        // unless it has the pair, and clears storage and returns to login when
        // it does not -- so navigating on a lone leftover authtoken produced an
        // immediate, unexplained bounce back to this screen's predecessor.
        const token = localStorage.getItem('authtoken');
        const refresh = localStorage.getItem('refreshToken');
        if (token && refresh) {
            // Same destination as a fresh sign-in; a reload must not land
            // somewhere different from the login that preceded it.
            dispatch(updatepageName("inventory"));
            navigate("/home/inventory");
        } else if (token || refresh) {
            // Half a session is not a session. Clear it so the operator gets a
            // clean login instead of a redirect loop.
            localStorage.removeItem('authtoken');
            localStorage.removeItem('refreshToken');
        }
    }, []);
    return (
        <Box sx={{ width: "100%",height:"100vh",display:{xs: "block", sm:"flex"}}}>
            <Toast ref={toast} />
                <Box sx={{ width:{ sm:"55%", md:"65%"} ,height:{ xs:"60%", sm:"auto"} , display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Box component="img" src={otpImg} sx={{ width: "100%", height: "100%", objectFit:"cover" }}></Box>
                </Box>
                <Box sx={{ width: { sm:"45%", md:"35%"},height:{ xs:"40%", sm:"auto"}, display: "flex", justifyContent: "center", alignItems: "center",flexDirection:"column",gap:"20px" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <Typography sx={{ color: "#6B7280", fontWeight: "700",fontSize:"16px", textAlign: "left", width: "100%" }}>Verify Your number</Typography>
                        <Typography sx={{ color: "#6B7280", fontWeight: "400",fontSize:"14px", textAlign: "left", width: "100%" }}>Enter OTP sent to <strong>+91&nbsp;{mobileno}</strong></Typography>
                        <Box sx={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                            {otp.map((value, index) => (
                                <InputBase
                                    key={index}
                                    value={value}
                                    onChange={(e) => handleChange(index, e)}
                                    onKeyDown={(e) => handleKeyDown(index, e)}
                                    inputRef={(el) => (inputRefs.current[index] = el)}
                                    sx={{
                                        width: "37.83px",
                                        height: "32px",
                                        borderRadius: "2px",
                                        borderWidth: "1px",
                                        borderStyle: "solid",
                                        borderColor: "#D9D9D9",
                                        textAlign: "center",
                                        fontSize: "16px",
                                    }}
                                    inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
                                />
                            ))}
                        </Box>
                    </Box>
                    <Button variant="contained" onClick={(e)=>handleOtpSubmit(e)}  disabled={!isOtpFilled} sx={{ width: "40%",width:"268px",height:"32px",borderRadius:"2px",textTransform: "none" , backgroundColor: !isOtpFilled ? "#ccc" : ""}}>{loading?<CircularProgress size="25px" sx={{color:"white"}}/>:'Continue'} </Button>
                    <Typography sx={{ fontSize: "14px", color: "#000" }}>
            Didn't receive OTP? &nbsp;
            {timer > 0 ? (
            <>
                <Typography component="span" sx={{ color: "#6B7280"}}>
                Resend OTP &nbsp;
                </Typography>
                    <Typography component="span" sx={{ color: "#ED1E79" }}>
                        {formatTime(timer)}
                    </Typography>
                </>
                ) : (
                    <Typography
                        component="span"
                        sx={{
                            color: resend_loading ? "#A0A0A0" : "#ED1E79", 
                            cursor: resend_loading ? "default" : "pointer",
                        }}
                        onClick={handleResendOtp}
                    >
                        Resend OTP
                    </Typography>
                )}
            </Typography>
        </Box>
        </Box>
    )
}